import {Component, OnInit} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ReactiveFormsModule} from '@angular/forms';
import {FaIconLibrary, FontAwesomeModule} from '@fortawesome/angular-fontawesome';
import {faPen, faSquarePlus, faTrash} from '@fortawesome/free-solid-svg-icons';
import {ToastrService} from 'ngx-toastr';
import {Router} from '@angular/router';

import {ClusterService} from '../../../services/cluster.service';
import {AuthService} from '../../../services/auth.service';

@Component({
    selector: 'app-cluster',
    imports: [CommonModule, ReactiveFormsModule, FontAwesomeModule],
    templateUrl: './cluster.component.html',
    styleUrl: './cluster.component.css'
})
export class ClusterComponent implements OnInit {
  clusters: any[] = [];
  isAdminUser: boolean = false;

  constructor(
    private clusterService: ClusterService,
    private auth: AuthService,
    private toastr: ToastrService,
    private router: Router,
    library: FaIconLibrary
  ) {
    library.addIcons(faTrash, faPen, faSquarePlus);
  }

  ngOnInit(): void {
    const roles = this.getUserRoles();
      const isPlatformSuperuser = this.auth.isSuperUser();
      this.isAdminUser = roles.includes('Admin') && !isPlatformSuperuser;
      if (isPlatformSuperuser) {
      this.router.navigate(['/dashboard']);
      return;
    }
    if (!this.isAdminUser) {
      this.router.navigate(['/visitor-management/select-register']);
      return;
    }
    this.loadClusters();
  }

  loadClusters(): void {
    this.clusterService.getClusters(1, 200).subscribe({
      next: (res: any) => {
        this.clusters = res?.results || [];
      }
    });
  }

  createCluster(): void {
    this.router.navigate(['/visitor-management/clusters/create']);
  }

  editCluster(clusterId: number): void {
    this.router.navigate([`/visitor-management/clusters/${clusterId}/edit`]);
  }

  deleteCluster(clusterId: number): void {
    this.clusterService.deleteCluster(clusterId).subscribe({
      next: () => {
        this.toastr.success('Cluster deleted.', 'Success');
        this.loadClusters();
      }
    });
  }

  private getUserRoles(): string[] {
    const userInfo = this.auth.getCurrentUserInfo();
    const role = userInfo?.role;
    if (Array.isArray(role)) {
      return role;
    }
    return role ? [role] : [];
  }
}
